import { SystemMessageType } from '@aid/core/types/enums/system-message-type.enum';

export class SystemMessage {
  creationDate?: Date;
  metadata: any;
  type?: SystemMessageType;
  resourceId?: number;
}
